/**
 * Curated starter tracks for the Audio panel's "Библиотека" section.
 *
 * Assets live under `public/editor-music/` (CC BY 4.0, Kevin MacLeod /
 * incompetech.com — see `public/editor-music/README.md` for full
 * attribution). Each track is referenced by a direct static URL (`src`),
 * not an S3 key. The render worker resolves these paths from `public/`, so
 * the same track is used in audition, playback and export.
 */
export type MusicCategory = 'Поп' | 'Фоновая' | 'Комедия' | 'Драйв' | 'Интрига';

export interface MusicTrack {
  id: string;
  title: string;
  mood: string;
  category: MusicCategory;
  src: string;
  duration?: number;
}

export const MUSIC_LIBRARY: MusicTrack[] = [
  {
    id: 'carefree',
    title: 'Carefree',
    mood: 'Лёгкий, беззаботный',
    category: 'Поп',
    src: '/editor-music/carefree.mp3',
    duration: 40,
  },
  {
    id: 'monkeys-spinning-monkeys',
    title: 'Monkeys Spinning Monkeys',
    mood: 'Игривый, комичный',
    category: 'Комедия',
    src: '/editor-music/monkeys-spinning-monkeys.mp3',
    duration: 40,
  },
  {
    id: 'wallpaper',
    title: 'Wallpaper',
    mood: 'Спокойный, фоновый',
    category: 'Фоновая',
    src: '/editor-music/wallpaper.mp3',
    duration: 40,
  },
  {
    id: 'sneaky-adventure',
    title: 'Sneaky Adventure',
    mood: 'Динамичный, интригующий',
    category: 'Интрига',
    src: '/editor-music/sneaky-adventure.mp3',
    duration: 40,
  },
  {
    id: 'fluffing-a-duck',
    title: 'Fluffing a Duck',
    mood: 'Энергичный, забавный',
    category: 'Комедия',
    src: '/editor-music/fluffing-a-duck.mp3',
    duration: 40,
  },
  {
    id: 'bossa-antigua',
    title: 'Bossa Antigua',
    mood: 'Расслабленный, боссанова',
    category: 'Фоновая',
    src: '/editor-music/bossa-antigua.mp3',
    duration: 40,
  },
  {
    id: 'cheery-monday',
    title: 'Cheery Monday',
    mood: 'Позитивный, бодрый',
    category: 'Поп',
    src: '/editor-music/cheery-monday.mp3',
    duration: 40,
  },
  { id: 'local-forecast-elevator', title: 'Local Forecast', mood: 'Лаунж, лёгкий джаз', category: 'Фоновая', src: '/editor-music/local-forecast-elevator.mp3', duration: 40 },
  { id: 'life-of-riley', title: 'Life of Riley', mood: 'Солнечный, акустический', category: 'Поп', src: '/editor-music/life-of-riley.mp3', duration: 40 },
  { id: 'amazing-plan', title: 'Amazing Plan', mood: 'Весёлый, мультяшный', category: 'Комедия', src: '/editor-music/amazing-plan.mp3', duration: 40 },
  { id: 'scheming-weasel', title: 'Scheming Weasel', mood: 'Хитрый, комедийный', category: 'Комедия', src: '/editor-music/scheming-weasel.mp3', duration: 40 },
  { id: 'jaunty-gumption', title: 'Jaunty Gumption', mood: 'Бодрый, приключенческий', category: 'Драйв', src: '/editor-music/jaunty-gumption.mp3', duration: 40 },
  { id: 'early-riser', title: 'Early Riser', mood: 'Свежий, мотивирующий', category: 'Поп', src: '/editor-music/early-riser.mp3', duration: 40 },
  { id: 'investigations', title: 'Investigations', mood: 'Расследование, тайна', category: 'Интрига', src: '/editor-music/investigations.mp3', duration: 40 },
  { id: 'sneaky-snitch', title: 'Sneaky Snitch', mood: 'Шпионский, ироничный', category: 'Интрига', src: '/editor-music/sneaky-snitch.mp3', duration: 40 },
  { id: 'vivacity', title: 'Vivacity', mood: 'Быстрый, оптимистичный', category: 'Драйв', src: '/editor-music/vivacity.mp3', duration: 40 },
  { id: 'b-roll', title: 'B-Roll', mood: 'Ритмичный, городской', category: 'Драйв', src: '/editor-music/b-roll.mp3', duration: 40 },
  { id: 'whiskey-on-the-mississippi', title: 'Whiskey on the Mississippi', mood: 'Фанк, уверенный грув', category: 'Драйв', src: '/editor-music/whiskey-on-the-mississippi.mp3', duration: 40 },
  { id: 'inspired', title: 'Inspired', mood: 'Вдохновляющий, спокойный', category: 'Фоновая', src: '/editor-music/inspired.mp3', duration: 40 },
  { id: 'cut-and-run', title: 'Cut and Run', mood: 'Напряжённый, быстрый', category: 'Интрига', src: '/editor-music/cut-and-run.mp3', duration: 40 },
];
